<template>
  <section>
    <ul class="filters-list">
      <li v-if="hasPermission('orders', 'archive_orders')">
        <router-link
          :to="{
            name: 'AllEMROrders',
            query: this.$route.query,
          }"
        >
          ALL
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <li>
        <router-link
          :to="{
            name: 'ActiveEMROrders',
            query: this.$route.query,
          }"
        >
          OPEN
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <li>
        <router-link
          :to="{
            name: 'PendingEMROrders',
            query: this.$route.query,
          }"
        >
          REJECTED
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <!-- <li>
        <router-link
          :to="{
            name: 'PartialEMROrders',
            query: this.$route.query,
          }"
        >
          PARTIAL
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li> -->
      <li v-if="hasPermission('orders', 'archive_orders')">
        <router-link
          :to="{
            name: 'CompleteEMROrders',
            query: this.$route.query,
          }"
        >
          FINALIZED
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <li v-if="hasPermission('orders', 'create_accession')">
        <router-link
          :to="{
            name: 'NotSentEMROrders',
            query: this.$route.query,
          }"
        >
          EMR NOT SENT
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <li>
        <router-link
          :to="{
            name: 'ArchiveEMROrders',
            query: this.$route.query,
          }"
        >
          ARCHIVED
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <li>
        <router-link
          :to="{
            name: 'EMROrdersWithIssues',
            query: this.$route.query,
          }"
        >
          EMR WITH ISSUES
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
    </ul>
  </section>
</template>
<script>
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";

export default {
  mixins: [UserPermissionsHelper],
};
</script>